module.exports = __webpack_public_path__ + "static/media/LogicWedge6_2_drag_2.bad0ebf0.png";